import React from "react";
import { apiService } from "../../../../services/api/api.service";
import { useDispatch, useSelector } from "react-redux";
import { setRefund, setRefunds } from "../../../../actions/hr/refunds.actions";
import { toast } from "react-toastify";
import bucketsSwap from "../../../../utils/supabaseUtils/BucketsSwap/bucketsSwap";
import { useTranslation } from "react-i18next";

export const RefundModalActions = ({ id, fileName, status }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { filters } = useSelector(state => state.refundsReducer);
  const { companyId } = useSelector(state => state.app.user);

  const fetchRefunds = async () => {
    try {
      const refundsResponse = await apiService.get(
        `/refunds?limit=${filters.perPage}&page=${filters.page}`
      );

      dispatch(setRefunds(refundsResponse.data?.refunds || []));
    } catch (error) {
      toast.error(t("failed_to_get_refund_list"));
    }
  };

  const acceptOrRejectRefund = async newStatus => {
    try {
      const response = await apiService.put(`/refunds/${id}`, {
        description: "",
        status: newStatus
      });

      dispatch(setRefund(response.data.refund));
      toast.success(t(response.data.message));

      await bucketsSwap({
        oldStatus: status,
        status: response.data.status,
        fileName,
        companyId
      });

      await fetchRefunds();
    } catch (error) {
      toast.error(t("failed_to_accept_refund"));
    }
  };

  return (
    <div className="refundButtons">
      {status === null && (
        <>
          <button
            className="accept"
            disabled={status === true}
            onClick={() => acceptOrRejectRefund(true)}
          >
            {t("Accept")}
          </button>
          <button
            className="reject"
            disabled={status === false}
            onClick={() => acceptOrRejectRefund(false)}
          >
            {t("Decline")}
          </button>
        </>
      )}
    </div>
  );
};
